module.exports = __webpack_public_path__ + "media/photo/Group 327-93f64717.png";